module.exports = __webpack_public_path__ + "img/esports_demo-1.34a5e47e.jpg";